import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { TooltipModule } from 'primeng/tooltip';
import { I18nModule, TranslationService } from '../../../i18n';
import { CplaceControlSkeletonModule } from '../cplace-control-skeleton';
import { CplaceControlService } from '../shared/cplace-control.service';
import { CplaceSingleIconControlComponent } from './';
import * as de from './lang/de.json';
import * as en from './lang/en.json';

@NgModule({
  declarations: [CplaceSingleIconControlComponent],
  imports: [CommonModule, CplaceControlSkeletonModule, DropdownModule, I18nModule, FormsModule, TooltipModule, HttpClientModule],
  exports: [CplaceSingleIconControlComponent],
  providers: [CplaceControlService],
})
export class CplaceSingleIconControlModule {
  constructor(private translationService: TranslationService) {
    this.translationService.addTranslation({
      translations: {
        en: en,
        de: de,
      },
    });
  }
}
